import React from "react";
import { useTranslation } from "react-i18next";
import * as S from "./checkbox.styles";

export const Checkbox = (props) => {
  const { t } = useTranslation();

  const renderCheckbox = (props) => {
    if (props.depends) {
      const field = props.register(props.name, { ...props.validation });
      return (
        <S.Fields
          small
          error={props.error}
          type={props.type}
          placeholder={
            props.label ? t(`${props.label}`) : t(`${props.placeholder}`)
          }
          checked={props.checked}
          onChange={(e) => {
            field.onChange(e);
            props.onchange(e.target.checked);
          }}
        />
      );
    } else {
      return (
        <S.Fields
          small
          error={props.error}
          type={props.type}
          placeholder={
            props.label ? t(`${props.label}`) : t(`${props.placeholder}`)
          }
          {...props.register(props.name, { ...props.validation })}
        />
      );
    }
  };

  return (
    <div>
      <S.FormGroup className="form-group">
        <S.FormLabelRadio small>
          {t(`${props.label}`)}
          <S.Required> *</S.Required>
        </S.FormLabelRadio>
        {renderCheckbox(props)}
      </S.FormGroup>
    </div>
  );
};
